import type { ReactNode } from 'react';

export interface Column<Row> {
  id: string;
  header: ReactNode;
  cell: (row: Row) => ReactNode;
  numeric?: boolean;
  /** Sort key; columns without one aren't sortable. */
  sortValue?: (row: Row) => number | string;
}

export interface SortState {
  column: string;
  direction: 'asc' | 'desc';
}

export function sortRows<Row>(
  rows: readonly Row[],
  columns: readonly Column<Row>[],
  sort: SortState | null,
): Row[] {
  const column = sort ? columns.find((c) => c.id === sort.column) : undefined;
  if (!sort || !column?.sortValue) return [...rows];
  const value = column.sortValue;
  const factor = sort.direction === 'asc' ? 1 : -1;
  return [...rows].sort((a, b) => {
    const x = value(a);
    const y = value(b);
    return (x < y ? -1 : x > y ? 1 : 0) * factor;
  });
}
